/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { styled } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import useStyles from '../styles';
import { updateFrom } from '../../../redux/Actions/createInstance.action';
import { ADD_USAGES } from '../../../redux/Constants/createInstance.constants';

const HeadTextField = styled(TextField)(() => ({
    marginTop: '12px',
    input: {
        height: '1px',
        // padding: '15px 10px',
        border: '1px 1px solid #70707063',
        borderRadius: '0px !important'
    }
}));

export default function Usages(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [usages, setUsages] = useState({
        adminLicenseLimit: 0,
        contentSourceLimit: 0,
        indexSizeLimit: 0,
        documentsLimit: 0,
        searchClientsLimit: 0,
        searchesLimit: 0,
        kcsLicenseLimit: 0,
        chatbotLicenseLimit: 0
    });

    const decimalVal = (event) => {
        if (event.key === '.' || event.key === '-') {
            event.preventDefault();
        }
    };
    const handleChange = (val) => (e) => {
        setUsages({
            ...usages,
            [val]: e.target.value
        });
    };

    useEffect(() => {
        dispatch(updateFrom(usages, ADD_USAGES));
    }, [usages]);

    useEffect(() => {
        if (props.val.usages) {
            const data = props.val.usages;
            setUsages({
                adminLicenseLimit: data.adminLicenseLimit,
                kcsLicenseLimit: data.kcsLicenseLimit,
                chatbotLicenseLimit: data.chatbotLicenseLimit,
                contentSourceLimit: data.contentSourceLimit,
                indexSizeLimit: data.indexSizeLimit,
                documentsLimit: data.documentsLimit,
                searchClientsLimit: data.searchClientsLimit,
                searchesLimit: data.searchesLimit
            });
        }
    }, [props.val]);
    return (
        <>
            <div className={classes.formContainer}>
                <h1 className={classes.heading}>Usage Limit</h1>
                <Grid container>
                    <div className={classes.boxSet}>
                        <Grid item xs={12} sm={6} md={3}>
                            <div className={classes.flexLast}>
                                <div className={classes.lastHeadtext}>Admin Panel Licenses</div>
                                <FormControl fullWidth sx={{ mx: 1 }}>
                                    <HeadTextField
                                        type="number"
                                        id="outlined-basic"
                                        FormHelperTextProps={{
                                            className: classes.helperText
                                        }}
                                        onKeyDown={decimalVal}
                                        error={
                                            usages.adminLicenseLimit < 0 ||
                                            usages.adminLicenseLimit === ''
                                        }
                                        helperText={
                                            (usages.adminLicenseLimit < 0 && 'Invalid data') ||
                                            (usages.adminLicenseLimit === '' &&
                                                'Field cannot be empty')
                                        }
                                        InputProps={{ inputProps: { min: 0 } }}
                                        value={usages.adminLicenseLimit}
                                        InputLabelProps={{
                                            style: { fontSize: '13px' }
                                        }}
                                        onChange={handleChange('adminLicenseLimit')}
                                    />
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <div className={classes.flexLast}>
                                <div className={classes.lastHeadtext}>KCS User Licenses</div>
                                <FormControl fullWidth sx={{ mx: 1 }}>
                                    <HeadTextField
                                        type="number"
                                        id="outlined-basic"
                                        FormHelperTextProps={{
                                            className: classes.helperText
                                        }}
                                        onKeyDown={decimalVal}
                                        error={
                                            usages.kcsLicenseLimit < 0 ||
                                            usages.kcsLicenseLimit === ''
                                        }
                                        helperText={
                                            (usages.kcsLicenseLimit < 0 && 'Invalid data') ||
                                            (usages.kcsLicenseLimit === '' &&
                                                'Field cannot be empty')
                                        }
                                        InputProps={{ inputProps: { min: 0 } }}
                                        value={usages.kcsLicenseLimit}
                                        InputLabelProps={{
                                            style: { fontSize: '13px' }
                                        }}
                                        onChange={handleChange('kcsLicenseLimit')}
                                    />
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <div className={classes.flexLast}>
                                <div className={classes.lastHeadtext}>Chatbot User Licensess</div>
                                <FormControl fullWidth sx={{ mx: 1 }}>
                                    <HeadTextField
                                        type="number"
                                        id="outlined-basic"
                                        FormHelperTextProps={{
                                            className: classes.helperText
                                        }}
                                        onKeyDown={decimalVal}
                                        error={
                                            usages.chatbotLicenseLimit < 0 ||
                                            usages.chatbotLicenseLimit === ''
                                        }
                                        helperText={
                                            (usages.chatbotLicenseLimit < 0 && 'Invalid data') ||
                                            (usages.chatbotLicenseLimit === '' &&
                                                'Field cannot be empty')
                                        }
                                        InputProps={{ inputProps: { min: 0 } }}
                                        value={usages.chatbotLicenseLimit}
                                        InputLabelProps={{
                                            style: { fontSize: '13px' }
                                        }}
                                        onChange={handleChange('chatbotLicenseLimit')}
                                    />
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <div className={classes.flexLast}>
                                <div className={classes.lastHeadtext}>No. of Content Sources</div>
                                <FormControl fullWidth sx={{ mx: 1 }}>
                                    <HeadTextField
                                        type="number"
                                        id="outlined-basic"
                                        FormHelperTextProps={{
                                            className: classes.helperText
                                        }}
                                        onKeyDown={decimalVal}
                                        error={
                                            usages.contentSourceLimit < 0 ||
                                            usages.contentSourceLimit === ''
                                        }
                                        helperText={
                                            (usages.contentSourceLimit < 0 && 'Invalid data') ||
                                            (usages.contentSourceLimit === '' &&
                                                'Field cannot be empty')
                                        }
                                        InputProps={{ inputProps: { min: 0 } }}
                                        InputLabelProps={{
                                            style: { fontSize: '13px' }
                                        }}
                                        value={usages.contentSourceLimit}
                                        onChange={handleChange('contentSourceLimit')}
                                    />
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <div className={classes.flexLast}>
                                <div className={classes.lastHeadtext}>Index Size</div>
                                <FormControl fullWidth sx={{ mx: 1 }}>
                                    <HeadTextField
                                        type="number"
                                        id="outlined-basic"
                                        FormHelperTextProps={{
                                            className: classes.helperText
                                        }}
                                        error={
                                            usages.indexSizeLimit < 0 ||
                                            usages.indexSizeLimit === ''
                                        }
                                        helperText={
                                            (usages.indexSizeLimit < 0 && 'Invalid data') ||
                                            (usages.indexSizeLimit === '' &&
                                                'Field cannot be empty')
                                        }
                                        onKeyDown={decimalVal}
                                        value={usages.indexSizeLimit}
                                        onChange={handleChange('indexSizeLimit')}
                                        InputProps={
                                            ({
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <div className={classes.endoreMent}>GB</div>
                                                    </InputAdornment>
                                                )
                                            },
                                            { inputProps: { min: 0 } })
                                        }
                                        InputLabelProps={{
                                            style: { fontSize: '13px' }
                                        }}
                                    />
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <div className={classes.flexLast}>
                                <div className={classes.lastHeadtext}>No.of Documents</div>
                                <FormControl fullWidth sx={{ mx: 1 }}>
                                    <HeadTextField
                                        type="number"
                                        id="outlined-basic"
                                        FormHelperTextProps={{
                                            className: classes.helperText
                                        }}
                                        error={
                                            usages.documentsLimit < 0 ||
                                            usages.documentsLimit === ''
                                        }
                                        helperText={
                                            (usages.documentsLimit < 0 && 'Invalid data') ||
                                            (usages.documentsLimit === '' &&
                                                'Field cannot be empty')
                                        }
                                        InputProps={{ inputProps: { min: 0 } }}
                                        value={usages.documentsLimit}
                                        onKeyDown={decimalVal}
                                        onChange={handleChange('documentsLimit')}
                                        InputLabelProps={{
                                            style: { fontSize: '13px' }
                                        }}
                                    />
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <div className={classes.flexLast}>
                                <div className={classes.lastHeadtext}>No. of search Clients</div>
                                <FormControl fullWidth sx={{ mx: 1 }}>
                                    <HeadTextField
                                        type="number"
                                        id="outlined-basic"
                                        FormHelperTextProps={{
                                            className: classes.helperText
                                        }}
                                        error={
                                            usages.searchClientsLimit < 0 ||
                                            usages.searchClientsLimit === ''
                                        }
                                        helperText={
                                            (usages.searchClientsLimit < 0 && 'Invalid data') ||
                                            (usages.searchClientsLimit === '' &&
                                                'Field cannot be empty')
                                        }
                                        InputProps={{ inputProps: { min: 0 } }}
                                        onKeyDown={decimalVal}
                                        InputLabelProps={{
                                            style: { fontSize: '13px' }
                                        }}
                                        value={usages.searchClientsLimit}
                                        onChange={handleChange('searchClientsLimit')}
                                    />
                                </FormControl>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <div className={classes.flexLast}>
                                <div className={classes.lastHeadtext}>
                                    Searches permitted per month
                                </div>
                                <FormControl fullWidth sx={{ mx: 1 }}>
                                    <HeadTextField
                                        type="number"
                                        id="outlined-basic"
                                        FormHelperTextProps={{
                                            className: classes.helperText
                                        }}
                                        error={
                                            usages.searchesLimit < 0 || usages.searchesLimit === ''
                                        }
                                        helperText={
                                            (usages.searchesLimit < 0 && 'Invalid data') ||
                                            (usages.searchesLimit === '' && 'Field cannot be empty')
                                        }
                                        onKeyDown={decimalVal}
                                        InputProps={{ inputProps: { min: 0 } }}
                                        InputLabelProps={{
                                            style: { fontSize: '13px' }
                                        }}
                                        value={usages.searchesLimit}
                                        onChange={handleChange('searchesLimit')}
                                    />
                                </FormControl>
                            </div>
                        </Grid>
                    </div>
                </Grid>
            </div>
        </>
    );
}
